import { render, staticRenderFns } from "./userPoint.vue?vue&type=template&id=30717cfe&scoped=true&"
import script from "./userPoint.vue?vue&type=script&lang=js&"
export * from "./userPoint.vue?vue&type=script&lang=js&"
import style0 from "./userPoint.vue?vue&type=style&index=0&id=30717cfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30717cfe",
  null
  
)

export default component.exports